<template>
  <form id="email_signup" @submit.prevent="handleSubmit" novalidate>
    <h4 class="text-xl mb-3">Stay in touch with us</h4>
    <div class="input-with-button">
      <input class="input-with-button__el" type="email" name="email" placeholder="Email" v-model="email" @input="clearMessages" :disabled="success || loading" />
      <button type="submit" class="input-with-button__button" :disabled="success || loading">
        <SubmitArrow />
        <span class="sr-only">Submit</span>
      </button>
    </div>

    <div>
      <div v-if="success && successMessage.length" class="success_message success">{{successMessage}}</div>
      <div v-if="error && errorMessage.length" class="error_message error">Please enter a valid email</div>
    </div>
  </form>
</template>

<script>
import SubmitArrow from '../../../templates/_includes/svg/icon-arrow-right.svg';

export default {
  name: "HubspotForm",

  components: {
    SubmitArrow,
  },

  data() {
    return {
      email: "",
      error: false,
      errorMessage: "",
      success: false,
      successMessage: "",
      loading: false,
      HUBSPOT_API: "https://api.hsforms.com/submissions/v3/integration/submit/20489130/c580fe64-d3e5-42cd-a9b8-1043e198958a",
    };
  },

  methods: {
    /**
     * Clears validation and messages
     */
    clearMessages() {
      this.error = false;
      this.errorMessage = "";
      this.success = false;
      this.successMessage = "";
    },

    /**
     * Handles the response from HubSpot for when
     * there are errors in the submitted data
     * @see https://legacydocs.hubspot.com/docs/methods/forms/submit_form for information
     * on HubSpot API errors
     */
    handleErrors({ errors }) {
      this.error = true;
      this.errorMessage="INVALID EMAIL ADDRESS";
    },

    /**
     * Handles the response from HubSpot for when
     * the data is accepted and submitted
     */
    handleSubmitted({ inlineMessage }) {
      this.success = true;
      this.successMessage = inlineMessage.replace(/(<([^>]+)>)/gi, ""); //strips tags
    },

    /**
     * Handles the response from HubSpot
     */
    handleResponse(response) {
      if (response.errors?.length) {
        this.handleErrors(response)
      } else {
        this.handleSubmitted(response)
      }
    },

    /**
     * Makes the request to HubSpot's api
     */
    async makeRequest(url, data) {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })

      return await response.json()
    },

    /**
     * Maps data into a format that HubSpot accepts
     */
    mapData() {
      return (
        {
          fields: [
            {
              name: "email",
              value: this.email,
            },
          ]
        }
      )
    },

    /**
     * Handles when the user submits the form
     */
    handleSubmit() {
      this.loading = true;

      this.clearMessages();

      const data = this.mapData();

      this.makeRequest(this.HUBSPOT_API, data)
      .then(response => {
        this.handleResponse(response)
      })
      .catch(err => {
        console.error(err)
      }).finally(() => {
        this.loading = false;
      });
    },
  }
}
</script>